import PlotterStore from './PlotterStore'

export default class RootStore {
  constructor() {
    this.plotterStore = new PlotterStore(this)
  }
}
